// @flow
import { type DocumentNode } from 'graphql';

import type { DateRange } from './types';
import { GET_ADD_ONS, GET_DATA_ENTRIES, GET_JOURNAL_ENTRIES, GET_LEDGER_ACCOUNTS } from './queries';
import multiMonthRangeToSingleMonthRanges from './multiMonthRangeToSingleMonthRanges';

type QueryList = Array<{ query: DocumentNode, variables: Object }>;

type MakeClientBooksQueriesArgs = {
  clientId: string,
  dateRange: DateRange,
  supplementalQueriesByMonth?: QueryList,
  supplementalQueriesForRange?: QueryList,
};

const makeClientBooksQueries = ({
  clientId,
  dateRange,
  supplementalQueriesByMonth = [],
  supplementalQueriesForRange = [],
}: MakeClientBooksQueriesArgs): QueryList => {
  const months = multiMonthRangeToSingleMonthRanges(dateRange);
  return [
    {
      query: GET_LEDGER_ACCOUNTS,
      variables: { clientId },
    },
    {
      query: GET_ADD_ONS,
      variables: { clientId },
    },
    ...months.map(monthRange => ({
      query: GET_JOURNAL_ENTRIES,
      variables: { clientId, ...monthRange },
    })),
    ...months.map(monthRange => ({
      query: GET_DATA_ENTRIES,
      variables: { clientId, ...monthRange },
    })),
    // $FlowFixMe Flow doesn't know about Array.prototype.flatMap yet
    ...supplementalQueriesByMonth.flatMap(query =>
      months.map(monthRange => ({
        query,
        variables: { clientId, ...monthRange },
      })),
    ),
    ...supplementalQueriesForRange.map(query => ({
      query,
      variables: { clientId, ...dateRange },
    })),
  ];
};

export default makeClientBooksQueries;
